import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {WeightedNodeOutputData} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {WeightedCardScratchpadState} from '../../scratchpad/weightedCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const deleteWeightedOutputsInputSchema = z.object({
  outputIds: z
    .array(z.number())
    .describe('The ids of the outputs to delete, make sure that at least 2 outputs remain'),
});

export default function deleteWeightedOutputsTool() {
  async function execute(
    params: ToolExecuteParams<typeof deleteWeightedOutputsInputSchema, WeightedCardScratchpadState>,
  ) {
    const {outputIds} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<WeightedCardScratchpadState>(
      agentScratchpad,
      NodeType.WEIGHTED,
    );

    const remainingOutputs = validatedScratchpad.card.outputs.filter(
      (output) => !outputIds.includes(output.id),
    ) as WeightedNodeOutputData[];

    if (remainingOutputs.length < 2) {
      return toolError('Cannot delete outputs: weighted cards must have at least 2 outputs');
    }

    validatedScratchpad.card.outputs = remainingOutputs;

    return toolResult(`Successfully deleted ${outputIds.length} output(s)`);
  }

  return tool<typeof deleteWeightedOutputsInputSchema, WeightedCardScratchpadState>({
    name: V2CardAgentToolName.DeleteWeightedOutputs,
    displayName: 'Deleting weighted outputs',
    description: 'Delete weighted outputs by ID. Minimum 2 outputs must remain.',
    inputSchema: deleteWeightedOutputsInputSchema,
    execute,
  });
}
